import React from "react";
import {CompactTestResultCard} from "./testResultView";

interface ValidationTabProps {
  policyCode: string;
  testResult: any;
  showProgress: boolean;
  showRetest: boolean;
  onValidate: () => void;
  onRegenerate: () => void;
  onCancel: () => void;
  onDownload: () => void;
}


const ValidationTab: React.FC<ValidationTabProps> = ({
  policyCode,
  testResult,
  showProgress,
  showRetest,
  onValidate,
  onRegenerate,
  onCancel,
  onDownload
}) => {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Run Validation</h2>
      <div className="space-y-4">
        <label className="font-medium text-sm">Generated Sentinel Policy</label>
         <pre className="p-3 border rounded bg-slate-50 max-h-64 overflow-auto text-xs font-mono">
       {policyCode}</pre>

        <div className="space-y-4">
          {testResult && (
            <div className="border rounded p-3">
              <h3 className="font-semibold mb-2">Test Summary</h3>
              <div>
               <CompactTestResultCard data={testResult} />
               </div>
            </div>
          )}
        </div>

        <div className="flex gap-2">
          {!showRetest && (
            <button
              disabled={!policyCode}
              className="px-4 py-2 bg-blue-600 text-white rounded"
              onClick={onValidate}
            >
              Validate
            </button>
          )}

          {showRetest && (
            <button
              disabled={!policyCode || showProgress}
              className="px-4 py-2 text-white rounded bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={onRegenerate}
            >
              Regenerate Policy
            </button>
          )}
          <button
              disabled={!policyCode}
              className="px-4 py-2 text-white rounded bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={onDownload}
            >
              Download
            </button>
          <button
              
              className="px-4 py-2 text-white rounded bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={onCancel}
            >
              Cancel
            </button>
             
            
        </div>
      </div>
    </div>
  );
};

export default ValidationTab;
